import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/NavBar";
import { useAppDispatch, useAppSelector } from "../store/store";
import AuthAction from "../store/auth/action";
import PasswordCriterias from "../components/PasswordCriterias";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ProfilePasswordPage = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { user, isLoading, error, updatePasswordSuccess } = useAppSelector((s) => s.auth);

    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showCurrent, setShowCurrent] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [criteriaMet, setCriteriaMet] = useState(false);
    const [errors, setErrors] = useState<Record<string, string>>({});

    useEffect(() => {
        return () => AuthAction.clearState(dispatch);
    }, [dispatch]);

    const validate = (): boolean => {
        const next: Record<string, string> = {};
        if (!currentPassword) next.currentPassword = "Ju lutemi shënoni fjalëkalimin e vjetër";
        if (!newPassword) next.newPassword = "Ju lutemi shënoni fjalëkalimin e ri";
        if (!confirmPassword) next.confirmPassword = "Ju lutemi konfirmoni fjalëkalimin";
        else if (confirmPassword !== newPassword) next.confirmPassword = "Fjalëkalimi nuk përputhet";
        setErrors(next);
        return Object.keys(next).length === 0;
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!validate() || !user?.email || !criteriaMet) return;
        AuthAction.updatePassword(user.email, currentPassword, newPassword, dispatch);
    };

    const onSuccessClose = () => {
        AuthAction.clearState(dispatch);
        navigate("/profile");
    };

    return (
        <div className="min-h-screen bg-[#f8f2ed] font-manrope">
            <Navbar />
            <div className="max-w-xl mx-auto px-4 py-6">
                <Link to="/profile" className="text-[#704e37] text-sm font-medium mb-4 inline-block">← Prapa në profilin</Link>
                <h1 className="text-2xl font-semibold text-[#704e37] mb-4">Ndrysho fjalëkalimin</h1>

                <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow p-6 space-y-4">
                    <div>
                        <label className="block text-sm text-gray-600 mb-1">Fjalëkalimi i vjetër</label>
                        <div className="relative">
                            <input
                                type={showCurrent ? "text" : "password"}
                                value={currentPassword}
                                onChange={(e) => setCurrentPassword(e.target.value)}
                                className="w-full border rounded px-3 py-2 pr-10"
                                placeholder="Fjalëkalimi i vjetër"
                                autoComplete="current-password"
                            />
                            <button
                                type="button"
                                onClick={() => setShowCurrent((s) => !s)}
                                className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 text-sm"
                            >
                                {showCurrent ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                        {errors.currentPassword && <p className="text-red-500 text-sm mt-0.5">{errors.currentPassword}</p>}
                    </div>
                    <div>
                        <label className="block text-sm text-gray-600 mb-1">Fjalëkalimi i ri</label>
                        <div className="relative">
                            <input
                                type={showNew ? "text" : "password"}
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                className="w-full border rounded px-3 py-2 pr-10"
                                placeholder="Fjalëkalimi i ri"
                                autoComplete="new-password"
                            />
                            <button
                                type="button"
                                onClick={() => setShowNew((s) => !s)}
                                className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 text-sm"
                            >
                                {showNew ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                        {errors.newPassword && <p className="text-red-500 text-sm mt-0.5">{errors.newPassword}</p>}
                    </div>
                    {newPassword && <PasswordCriterias password={newPassword} onMet={setCriteriaMet} />}
                    <div>
                        <label className="block text-sm text-gray-600 mb-1">Konfirmo fjalëkalimin e ri</label>
                        <div className="relative">
                            <input
                                type={showConfirm ? "text" : "password"}
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className="w-full border rounded px-3 py-2 pr-10"
                                placeholder="Konfirmo fjalëkalimin e ri"
                                autoComplete="new-password"
                            />
                            <button
                                type="button"
                                onClick={() => setShowConfirm((s) => !s)}
                                className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 text-sm"
                            >
                                {showConfirm ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                        {errors.confirmPassword && <p className="text-red-500 text-sm mt-0.5">{errors.confirmPassword}</p>}
                    </div>
                    {error && <p className="text-red-500 text-sm">{error}</p>}
                    <button
                        type="submit"
                        disabled={isLoading || !criteriaMet}
                        className="w-full py-3 rounded-lg bg-[#704e37] text-white font-medium hover:opacity-90 disabled:opacity-50"
                    >
                        {isLoading ? "Duke ruajtur..." : "Ruaj"}
                    </button>
                </form>
            </div>

            {updatePasswordSuccess && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
                    <div className="bg-white rounded-xl shadow-lg max-w-sm w-full p-6 text-center">
                        <p className="font-medium text-gray-800 mb-1">Sukses</p>
                        <p className="text-gray-600 text-sm mb-4">Fjalëkalimi u ndryshua me sukses.</p>
                        <button onClick={onSuccessClose} className="w-full py-2.5 rounded-lg bg-[#704e37] text-white font-medium">
                            Mbyll
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProfilePasswordPage;
